export default "__VITE_ASSET__EBzP4x7i__"